import { Link } from "react-router-dom";
import { ArrowLeft, GraduationCap } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

export default function Tutorials() {
  return (
    <div className="min-h-screen overflow-x-clip bg-crave-bg font-sans text-crave-cream">
      <Seo
        title="Tutorials | Foodie Crave: Discover & Dine"
        description="Step-by-step guides for getting the most out of Foodie Crave — coming soon."
        path="/tutorials"
        robots="noindex, follow"
      />
      <Navbar />
      <main>
        <section className="relative overflow-hidden pt-32 pb-24 md:pt-44 md:pb-32" data-testid="tutorials-page">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-48 -left-48 h-[36rem] w-[36rem] rounded-full bg-crave-red/25 blur-[140px]"
          />
          <div className="relative mx-auto max-w-3xl px-6 md:px-12">
            <Reveal>
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-crave-gold/30 bg-crave-gold/10 text-crave-gold">
                <GraduationCap className="h-5 w-5" aria-hidden="true" />
              </span>
              <p className="mt-6 text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">
                Tutorials
              </p>
              <h1 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-crave-cream sm:text-5xl md:text-6xl">
                Guides are on the way
              </h1>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-crave-muted md:text-lg">
                Step-by-step walkthroughs for discovering restaurants, saving places, tracking
                visits, and inviting friends will arrive with launch. Early testers get them first.
              </p>
              <Link
                to="/"
                data-testid="tutorials-home-link"
                className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-crave-gold px-7 py-3.5 text-sm font-bold text-crave-bg transition-colors duration-300 hover:bg-crave-cream"
              >
                <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                Back to home
              </Link>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
